/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import {
  setDoc,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  writeBatch,
} from "firebase/firestore";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { db } from "../../../firebase";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Form from "react-bootstrap/Form";
import usePagination from "../../helper/paginate/Pagination";
import "./DataTableDemo.css";
import { Link, useNavigate } from "react-router-dom";
import { ComponentToPrint } from "./ComponentToPrint";
import { useSelector } from "react-redux";
import { CSVLink, CSVDownload } from "react-csv";
import { fetchDate } from "../../../utils/globleFunc";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import "moment/locale/ar";
import "moment/locale/fr";
import apicache from "../../clearCach/clear";
import { Timestamp } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import { Menu, Dropdown, message } from "antd";
import API from "../../../utils/api-client";
import useIsDark from "../../../utils/isDark";
import { Edit } from "lucide-react";
const DigitalProductsDataTable = ({
  filter,
  orders,
  pageSize,
  setData,
  setLgShow,
  onUpdateOrder,
}) => {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);
  const [expandedRows, setExpandedRows] = useState(null);
  const productdata = useSelector((state) => state.ProductsReducer);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const [bluck, setBluck] = useState("");
  const [deleveryCompany, setDeleveryCompany] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);
  let [page, setPage] = useState(1);
  const isDark = useIsDark();
  const PER_PAGE = pageSize;
  const count = Math.ceil(orders.length / PER_PAGE);
  const _DATA = usePagination(orders, PER_PAGE);
  const products = useSelector((state) => state.ProductsReducer);
  const [showSubmenus, setShowSubmenus] = useState({});
   const currencyMap = {
    دج: {
      ar: "دج",
      fr: "DA",
      en: "DZD",
    },
  };
  const localizedCurrency =
    currencyMap[store.currencySymbol]?.[i18n.language] || store.currencySymbol;
  const STATUS_LABELS = {
    0: "جديد",
    1: "انتظار دفع العميل",
    2: "انتظار تأكيد الدفع",
    3: "مدفوع و انتظار المنتج",
    4: "الدفع مرفوض",
    5: "مكتملة",
  };
  const STATUS_CONFIG = {
    0: {
      label: t("orders.new"),
      icon: "bi bi-file-earmark-plus",
      image: "https://cdn-icons-png.flaticon.com/512/10608/10608900.png",
    },
    1: {
      label: t("dashboard.digitalcards.statuses.waitingPayment"),
      icon: "bi bi-credit-card",
      image: "https://cdn-icons-png.flaticon.com/512/6607/6607497.png",
    },
    2: {
      label: t("dashboard.digitalcards.statuses.waitingConfirmation"),
      icon: "bi bi-clock-history",
      image: "https://cdn-icons-png.flaticon.com/512/18964/18964041.png",
    },
    3: {
      label: t("orders.paid"),
      icon: "bi bi-check-circle",
      image: "https://cdn-icons-png.flaticon.com/128/8888/8888205.png",
    },
    4: {
      label: t("services.foorCall.status.rejected"),
      icon: "bi bi-x-circle",
      image: "https://cdn-icons-png.flaticon.com/128/391/391247.png",
    },
    5: {
      label: t("ui.completed"),
      icon: "bi bi-check-all",
      image: "https://cdn-icons-png.flaticon.com/128/6815/6815043.png",
    },
  };
  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };
  const [errorMessage, setErrorMessage] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();

    const interval = setInterval(() => fetchAndSetCurrentDate(), 60000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    // Vérifier les commandes toutes les minutes
    const interval = setInterval(() => {
      const now = new Date();
      // Ne vérifier que vers minuit pour économiser des ressources
      if (now.getHours() === 0 && now.getMinutes() <= 1) {
        orders.forEach((order) => {
          checkAndUpdateStatusAtMidnight(order);
        });
      }
    }, 3600000);

    return () => clearInterval(interval);
  }, [orders]);

  moment.defineLocale("fr-num", {
    parentLocale: "fr",
    months: moment.locales("fr").months,
    monthsShort: moment.locales("fr").monthsShort,
    weekdays: moment.locales("fr").weekdays,
    weekdaysShort: moment.locales("fr").weekdaysShort,
    weekdaysMin: moment.locales("fr").weekdaysMin,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm",
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      ss: "%d secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "une année",
      yy: "%d années",
    },
    preparse: function (string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(match);
      });
    },
  });

  useEffect(() => {
    if (errorMessage) {
      Swal.fire({
        title: t("datatable_templating_demo.error"),
        text: errorMessage,
        icon: "error",
        confirmButtonText: t("referral2.ok"),
      }).then(() => {
        setErrorMessage("");
      });
    }
  }, [errorMessage]);

  const dateBodyTemplate = (rowData) => {
    const timestamp = rowData.timeStamp.seconds * 1000;
    const now = Date.now();
    const date = moment(timestamp).locale("fr-num"); // تعيين اللغة الفرنسية مع الأرقام

    const diff = now - timestamp;

    if (diff < 60000) {
      // أقل من دقيقة واحدة
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 1000)}{" "}
          {t("orders.datatable_templating_demo.seconds")}
        </span>
      );
    } else if (diff < 3600000) {
      // أقل من ساعة واحدة
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 60000)}{" "}
          {t("orders.datatable_templating_demo.minutes")}
        </span>
      );
    } else if (diff < 86400000) {
      // أقل من يوم واحد
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 3600000)}{" "}
          {t("orders.datatable_templating_demo.hours")}
        </span>
      );
    } else if (diff < 604800000) {
      // أقل من أسبوع واحد
      return (
        <span>
          {t("orders.datatable_templating_demo.since")}{" "}
          {Math.floor(diff / 86400000)}{" "}
          {t("orders.datatable_templating_demo.days")}
        </span>
      );
    } else if (diff < 604800000 + 86400000) {
      // أقل من أسبوع واحد
      return (
        <span>
          {" "}
          {t("orders.datatable_templating_demo.since")}{" "}
          {t("orders.datatable_templating_demo.a_week")}
        </span>
      );
    } else {
      return <span>{date.format("YYYY-MM-DD, H:mm:ss")}</span>;
    }
  };

  const orderTotal = (rowData) => {
    return (
      <>
        <span className="bg-[#faf1ff] dark:bg-[#3c3a3d] text-[#9e68ba] dark:text-[#e4b8e4] px-3 py-1 rounded-lg">
          {rowData.total} {localizedCurrency}
        </span>
      </>
    );
  };

  const customerName = (rowData) => {
    return (
      <Link
        style={{ textDecoration: "none" }}
        to={`/orders/details`}
        state={{
          from: {
            ...rowData,
          },
          product: productdata.filter(
            (product) => product.id === rowData.productId
          )[0],
          products: productdata,
        }}
      >
        {rowData.name}
      </Link>
    );
  };

  const changeStatus = async (data, status) => {
    const currentTime = new Date();
    const updatedStatusTimeline = [
      ...(data.statusTimeline || []),
      { status, timestamp: currentTime, ownby: account?.name },
    ];

    try {
      const dataToUpdate = {
        ...data,
        status: status,
        statusTimeline: updatedStatusTimeline,
      };

      if (status === 5) {
        // alert(dataToUpdate.id);

        try{
          const response = await axios.post("https://master.foorweb.online/api/digital/orders/deliver-content", {
          id: dataToUpdate.id,
        });
        const updatedOrder = {
          ...response.data.order,
          id: response.data.orderId,
          timeStamp: new Timestamp(
            response.data.order.timeStamp._seconds,
            response.data.order.timeStamp._nanoseconds
          ),
        };
        onUpdateOrder(updatedOrder);
        }catch(e){
          console.error("Error delivering content via API:", e);
        }
      } else {
        const response = await API.put("digital/orders/update", {
          data: dataToUpdate,
        });
        const updatedOrder = {
          ...response.data.order,
          id: response.data.orderId,
          timeStamp: new Timestamp(
            response.data.order.timeStamp._seconds,
            response.data.order.timeStamp._nanoseconds
          ),
        };
        console.log("------------------");
        console.log(updatedOrder);
        onUpdateOrder(updatedOrder);
      }
    } catch (error) {
      console.error("Error updating order via API:", error);
    }
  };

  const darkModeStyles = `
  /* Styles pour le mode sombre du DataTable */
  .dark .p-datatable .p-datatable-thead > tr > th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
    background-color: #181919 !important;
  }

  .dark .p-datatable .p-datatable-tbody > tr > td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
    border-left: 1px solid #1e1e1e !important;
  }


  /* Pour les bordures du tableau */
  .dark .p-datatable {
    border-color: #3c3a3d !important;
  }

  /* Pour les éléments expandables */
  .dark .p-datatable .p-row-expansion {
    background-color: #141414 !important;
    color: #d1d5db !important;
  }
`;

  const getAllowedStatuses = (currentStatus) => {
    switch (currentStatus) {
      case 0:
        return [1, 2, 3, 4];
      case 1:
        return [3, 4];
      case 2:
        return [3, 4];
      case 3:
        return [5];
      case 4:
        return [];
      case 5:
        return [];
      default:
        return [];
    }
  };

  const rowExpansionTemplate = (data) => {
    const addIpToAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_block"),
        text: t("orderDetails.alerts.block.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("ship.confirm_block_button"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              await updateDoc(storeDocRef, {
                Adressipblock: arrayUnion(data.ipAddress),
              });
              apicache(account, products);
              Swal.fire(t("ship.block_success"), ". تم حظر عنوان الايبي بنجاح", "success");
            } catch (error) {
              console.error("Error adding الايبي: ", error);
              Swal.fire(t("ship.error"), ". حدث خطأ أثناء حظر عنوان الايبي", "error");
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(t("ship.error"), ". لا يوجد عنوان الايبي في الطلب", "error");
          }
        }
      });
    };
    const toggleSubmenu = (productId) => {
      setShowSubmenus((prevShowSubmenus) => ({
        ...prevShowSubmenus,
        [productId]: !prevShowSubmenus[productId],
      }));
    };
    const onDelete = async (product) => {
      try {
        const orderRef = doc(db, "orders", data.id); // استبدل "وثيقة_طلبك" بمعرف الوثيقة الفعلي
        await updateDoc(orderRef, {
          products: arrayRemove(product), // استخدم الكائن الكامل للحذف
        });
      } catch (e) {
        console.error("خطأ عند حذف المنتج: ", e);
      }
    };
    const removeIpFromAdressipblock = async (data) => {
      Swal.fire({
        title: t("ship.confirm_delete"),
        text: t("orderDetails.alerts.unblock.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "rgb(141, 93, 167)",
        cancelButtonColor: "#e87778",
        confirmButtonText: t("orderDetails.alerts.unblock.confirm"),
        cancelButtonText: t("annule"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          const storeDocRef = doc(db, "store", store.id);

          if (data.ipAddress) {
            try {
              await updateDoc(storeDocRef, {
                Adressipblock: arrayRemove(data.ipAddress),
              });
              Swal.fire(t("ship.delete_success"), ". تم حذف عنوان الايبي بنجاح", "success");
            } catch (error) {
              console.error("Error removing الايبي: ", error);
              Swal.fire(t("ship.error"), ". حدث خطأ أثناء حذف عنوان الايبي", "error");
            }
          } else {
            console.error("No الايبي address found in data");
            Swal.fire(t("ship.error"), ". لا يوجد عنوان الايبي في الطلب", "error");
          }
        }
      });
    };
    const timestamp = data.timeStamp;
    const date = new Date(timestamp.seconds * 1000); // تحويل ثواني الوقت إلى مللي ثواني وإنشاء كائن التاريخ
    const formattedDate = date.toLocaleString();
    const product = productdata.find(
      (product) => product.id === data.productId
    );
    let productsToShow = [];
    if (data.products && data.products.length > 0) {
      productsToShow = data.products.map((p) =>
        productdata.find((product) => product.id === p.id)
      );
    }
    return (
      <div className="orders-subtable row">
        <div className="max-w-2xl mx-auto py-0 md:px-8">
          {data.nameproduct ? (
            <>
              {data.products ? (
                <ul>
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between dark:!border-[#3c3a3d] w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={data.image ? data.image : "/product-foorweb.png"}
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {data.nameproduct}
                        </div>
                        <span className="text-sm">
                          {data.total} {localizedCurrency}
                        </span>
                      </li>
                    </div>
                  </div>
                </ul>
              ) : (
                <ul>
                  <div className="max-w-2xl mx-auto py-0 md:px-8">
                    <div className="d-flex justify-content-between w-100 p-1-2 border4">
                      <li className="flex gap-4 items-center">
                        <img
                          src={data.image ? data.image : "/product-foorweb.png"}
                          className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                        />
                        <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                          {data.nameproduct}
                        </div>
                        <span className="text-sm">
                          {data.total} {localizedCurrency}
                        </span>
                      </li>
                    </div>
                  </div>
                </ul>
              )}
            </>
          ) : data.products ? (
            <ul>
              {data?.nameproduct
                ? productsToShow.map((product) => (
                    <div
                      className="max-w-2xl mx-auto py-0 md:px-8"
                      key={product?.id}
                    >
                      <div className="d-flex justify-content-between w-100 p-1-2 border4">
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product?.image
                                ? product?.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product?.name}
                          </div>
                          <span className="text-sm">
                            {product?.price} {localizedCurrency}
                          </span>
                        </li>
                      </div>
                    </div>
                  ))
                : data.products.map((product, index) => (
                    <div className="max-w-2xl mx-auto py-0 md:px-8">
                      <div className="d-flex justify-content-between w-100 p-1-2 border4">
                        <li className="flex gap-4 items-center">
                          <img
                            src={
                              product.image
                                ? product.image
                                : "/product-foorweb.png"
                            }
                            className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                          />
                          <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                            {product.name}
                          </div>
                          <span className="text-sm">
                            {data.total} {localizedCurrency}
                          </span>
                        </li>
                      </div>
                    </div>
                  ))}
            </ul>
          ) : (
            <ul>
              <div className="d-flex justify-content-between w-100 p-1-2 border4">
                <li className="flex gap-4 items-center">
                  <img
                    src={product ? product.image : "/product-foorweb.png"}
                    className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff]"
                  />
                  <div className="flex-1 text-left flex items-center gap-x-1 text-truncate">
                    {product ? product.name : ""}
                  </div>
                  <span className="text-sm">
                    {data.total} {localizedCurrency}
                  </span>
                </li>
              </div>
            </ul>
          )}
        </div>

        <div className="mt-2 dark:text-gray-300">
          <p className="text-gray-600 text-sm font-semibold sm:text-xs dark:text-gray-300">
            {t("orders.datatable_templating_demo.order_status_updates")}:
          </p>
          <div
            className="flex items-center"
            style={{ overflowX: "auto", whiteSpace: "nowrap" }}
          >
            {data.statusTimeline ? (
              data.statusTimeline.map((statusUpdate, idx, array) => {
                const isFirstItem = idx === 0;
                return (
                  <div
                    key={idx}
                    className={`flex items-center dark:text-gray-300 ${
                      !isFirstItem ? "ml-2" : ""
                    }`}
                  >
                    {!isFirstItem && (
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/3575/3575967.png"
                        alt=""
                        className="w-4 h-4"
                        style={{ marginLeft: "5px", marginRight: "5px" }}
                      />
                    )}
                    <img
                      src={
                        statusUpdate.status === "1"
                          ? "https://cdn-icons-png.flaticon.com/512/10608/10608900.png"
                          : statusUpdate.status === "2"
                          ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                          : statusUpdate.status === "9"
                          ? "https://cdn-icons-png.flaticon.com/128/1688/1688988.png"
                          : statusUpdate.status === "3"
                          ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                          : statusUpdate.status === "4"
                          ? "https://cdn-icons-png.flaticon.com/128/1559/1559859.png"
                          : statusUpdate.status === "5"
                          ? "https://cdn-icons-png.flaticon.com/128/6815/6815043.png"
                          : statusUpdate.status === "6"
                          ? "https://cdn-icons-png.flaticon.com/128/391/391247.png"
                          : statusUpdate.status === "11-1"
                          ? "https://cdn-icons-png.flaticon.com/128/2593/2593514.png"
                          : statusUpdate.status === "11-2"
                          ? "https://cdn-icons-png.flaticon.com/128/9946/9946401.png"
                          : statusUpdate.status === "11-3"
                          ? "../agenda.png"
                          : statusUpdate.status === "11-4"
                          ? "https://cdn-icons-png.flaticon.com/128/8402/8402548.png"
                          : statusUpdate.status === "11-5"
                          ? "https://cdn-icons-png.flaticon.com/128/7787/7787073.png"
                          : "https://cdn-icons-png.flaticon.com/128/11442/11442042.png"
                      }
                      className="w-10 h-10"
                      alt=""
                    />
                  </div>
                );
              })
            ) : (
              <p className="text-gray-700 text-center dark:text-gray-400 mx-auto">
                {t("orders.datatable_templating_demo.no_Update")}
              </p>
            )}
          </div>
        </div>
        <div>
          <h4 className=" font-semibold sm:text-lg dark:text-gray-300">
            {t("orders.datatable_templating_demo.receive_order")}
          </h4>
          <p className="text-[#9e68ba]">{formattedDate}</p>
        </div>
        <div className="mt-2 grid gap-8 sm:grid-cols-2 lg:grid-cols-2">
          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.full_name")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>{data.name}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.phone_number")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {" "}
                  {data.isValid ? (
                    <i class="fs-3" onClick={() => handlePay(data)}>
                      <img src={"/lock.png"} className="mx-auto" />
                    </i>
                  ) : (
                    <a
                      href={`tel:${data.phone}}`}
                      style={{ textDecoration: "none" }}
                    >
                      {data.phone}
                    </a>
                  )}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {" "}
                {t("orders.datatable_templating_demo.email")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>{data.email ? data.email : t("ui.notAvailable")}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.customer_note")} :{" "}
              </p>
              <p className="m-0 text-success">
                <b>
                  {data?.note && data?.note?.trim() !== ""
                    ? data?.note?.trim()
                    : t("orders.datatable_templating_demo.no_note")}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.ip_address")} :
              </p>
              <p className="m-0 text-success">
                <b>{data.ipAddress ? data.ipAddress : "-"}</b>
              </p>
            </div>
          </div>

          <div className=" justify-content-between w-100 p-1-2 border4 dark:!border-[#3c3a3d]">
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.product_value")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total} {store.currencySymbol}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.quantity")} :
              </p>
              <p className="m-0 text-success">
                <b> {data.qty} </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {" "}
                {t("orders.datatable_templating_demo.product_content")} :
              </p>
              <p className="m-0 text-success">
                <b>{data.products[0].key ?? t("ui.toBeDetermined")}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">{t("ui.paymentMethodLabel")}</p>
              <p className="m-0 text-success">
                <b>{data.paymentMethod ?? t("ui.toBeDetermined")}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">{t("ui.orderStatusLabel")}</p>
              <p className="m-0 text-success">
                <b>{STATUS_LABELS[data.status] ?? t("unspecified")}</b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            {data.status == 2 && (
              <div className="d-flex justify-content-between w-100 p-1-2-3">
                <p className="m-0">{t("ui.paymentProofLabel")}</p>
                {data.paymentProof ? (
                  <p
                    className="m-0 font-bold cursor-pointer text-[#9e68ba] hover:opacity-75 transition"
                    onClick={() => navigateToOrder(data)}
                  >
                    {t("Products.Table.expand.default.available")}
                  </p>
                ) : (
                  <p className="m-0 text-danger font-bold">{t("dontexist")}</p>
                )}
              </div>
            )}
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <p className="m-0">
                {t("orders.datatable_templating_demo.grand_total")} :
              </p>
              <p className="m-0 text-success">
                <b>
                  {data.total} {localizedCurrency}
                </b>
              </p>
            </div>
            <hr className="m-0 p-0" />
            <div className="d-flex justify-content-between w-100 p-1-2-3 ">
              <button
                type="button"
                class="btn btn-outline-danger"
                onClick={() => addIpToAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.block")}
              </button>
              <button
                type="button"
                class="btn btn-outline-warning"
                onClick={() => removeIpFromAdressipblock(data)}
              >
                {t("orders.datatable_templating_demo.delete")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleDelete = async (data) => {
    Swal.fire({
      title: t("ship.confirm_delete"),
      html: `
        <p>هل أنت متأكد من القيام بذلك؟</p>
        <small style="display:block;margin-top:10px;color:gray;">
          تحذير : إذا أنت في حالة المحذوفة  سيتم حذف الطلب نهائيا.
        </small>
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(141, 93, 167)",
      cancelButtonColor: "#e87778",
      confirmButtonText: t("ship.yes"),
      cancelButtonText: t("ship.no"),
    }).then((result) => {
      if (result.isConfirmed) {
        const audio = new Audio("/Mouth woosh_42.wav");
        audio.play();

        if (data.deleveryStatus === "8") {
          // حذف نهائي
          setDoc(doc(db, "orders", data.id), {
            ...data,
            deleted: 1,
          }).then();
        } else {
          // نقل إلى حالة المحذوفة
          setDoc(doc(db, "orders", data.id), {
            ...data,
            deleveryStatus: "8",
          }).then();
        }
      }
    });
  };

  const navigate = useNavigate();

  const navigateToOrder = (rowData) => {
    if (rowData && rowData.id) {
      navigate(`/digital-order-profile/${rowData.id}`, {
        state: {
          orderData: rowData,
          productData: productdata.find(
            (product) => product.id === rowData.productId
          ),
        },
      });
    } else {
      console.error("Order ID not found!");
    }
  };

  const handleUpdate = async (rowData) => {
    setData(rowData);
    setLgShow(true);
  };

  const actionTemplate = (rowData) => {
    return (
      <Dropdown
        overlay={
          <Menu className="">
            <Menu.Item
              key="1"
              className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss bi "
              size={16}
              onClick={
                !!account.store
                  ? () => handleUpdate(rowData)
                  : () => {
                      message();
                    }
              }
            >
              <i
                style={{
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-file-pen-line hover:text-green-500 ml-2"
                >
                  <path d="m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2" />
                  <path d="M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
                  <path d="M8 18h1" />
                </svg>
                {t("orders.datatable_templating_demo.edit")}
              </i>
            </Menu.Item>
            <Menu.Item
              key={rowData.id}
              className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss  hover:text-green-500"
              size={16}
              onClick={() => navigateToOrder(rowData)} // Pass the entire rowData
            >
              <i
                style={{
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                  alignItems: "center",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-eye ml-2 hover:text-green-500"
                >
                  <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
                {t("orders.datatable_templating_demo.preview")}
              </i>
            </Menu.Item>

            <Menu.Item
              key="3"
              className="rtl:text-right ltr:text-left rtl:direction-rtl ltr:direction-ltr ss1 "
              size={16}
              onClick={
                !!account.store
                  ? () => {
                      handleDelete(rowData);
                    }
                  : () => {
                      message();
                    }
              }
            >
              <i
                style={{
                  color: "#f21919",
                  display: "flex",
                  textAlign: "center",
                  paddingRight: "2px",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f21919"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-trash2-icon lucide-trash-2 ml-2"
                >
                  <path d="M3 6h18" />
                  <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                  <line x1="10" x2="10" y1="11" y2="17" />
                  <line x1="14" x2="14" y1="11" y2="17" />
                </svg>
                {t("orders.datatable_templating_demo.delete")}
              </i>
            </Menu.Item>
          </Menu>
        }
      >
        <button className="bot1 dark:bg-[#181919] dark:!text-gray-300 p-2">
          <Edit className="w-5 h-5" />
        </button>
      </Dropdown>
    );
  };

  const groubeUpdates = async () => {
    const batch = writeBatch(db);
    const telegramBotToken = "6672968395:AAHFokejZq4r6GRRDHlm2FDqXk0-pXoQmOs";
    const chatId = store.Idtelegram;
    const allMessage = `📢 تم تغيير حالات طلباتك بشكل جماعي. تفقد متجرك للاطلاع على المستجدات وتحديثات الطلبات. 🛍️💼`;

    if (bluck != "") {
      if (bluck === "7") {
        selectedProducts.forEach((order) => {
          const sfRef = doc(db, "orders", order.id);
          batch.set(sfRef, { ...order, deleted: 1 });
        });
      } else if (bluck === "8") {
        const invalidOrders = selectedProducts.filter(
          (order) => order.status !== 0 && order.status !== 1
        );

        if (invalidOrders.length > 0) {
          Swal.fire(
            t("ship.error"),
            "يرجى تحديد الطلبات غير المدفوعة فقط (الطلبات الجديدة او في انتظار دفع العميل)",
            "error"
          );
          return;
        }

        const result = await Swal.fire({
          title: t("ui.confirmReminder"),
          text: t("ui.reminderConfirmPrompt"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "rgb(141, 93, 167)",
          cancelButtonColor: "#e87778",
          confirmButtonText: t("ui.sendReminderConfirm"),
          cancelButtonText: t("annule"),
        });

        if (result.isConfirmed) {
          try {
            let domain;
            if (account?.store?.includes("foorweb")) {
              const storeName = account.store.split(".")[0];
              domain = `${storeName}.foorweb.online/`;
            } else {
              domain = `${account.store}`;
            }

            const orderIds = selectedProducts.map((order) => order.id);
            await API.post("digital/orders/send-bulk-reminders", {
              orderIds: orderIds,
              baseUrl: domain,
              user: account.user,
            });

            const reminderBatch = writeBatch(db);
            selectedProducts.forEach((order) => {
              const orderRef = doc(db, "orders", order.id);
              const currentReminderCount = order.reminderCount || 0;
              reminderBatch.update(orderRef, {
                reminderCount: currentReminderCount + 1,
              });
            });
            await reminderBatch.commit();
            Swal.fire({
              title: t("Products.Table.ecomanager.fullSuccess"),
              text: t("ui.remindersSent"),
              icon: "success",
              confirmButtonText: t("ship.yes"),
              confirmButtonColor: "rgb(141, 93, 167)",
            });
          } catch (error) {
            console.error("خطأ في إرسال التذكيرات:", error);
            Swal.fire(t("ship.error"), "حدث خطأ أثناء إرسال التذكيرات", "error");
          }
        }
        return;
      } else {
        selectedProducts.forEach((order) => {
          const sfRef = doc(db, "orders", order.id);
          batch.update(sfRef, { status: parseInt(bluck) });
        });
      }

      axios
        .post(`https://api.telegram.org/bot${telegramBotToken}/sendMessage`, {
          chat_id: chatId,
          text: allMessage,
        })
        .then((response) => {
          console.log("تم إرسال الإشعار بنجاح");
        })
        .catch((error) => {
          console.error("حدث خطأ أثناء إرسال الإشعار", error);
        });

      try {
        await batch.commit();
        Swal.fire({
          title: t("cashBack.swal.updateSuccess.title"),
          icon: "success",
          confirmButtonText: t("ship.yes"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      } catch (error) {
        Swal.fire({
          title: t("foorAi.history.error.generic"),
          text: t("FormSettings.alerts.save_error.text"),
          icon: "error",
        });
      }
    }
  };

  const selectTemplate = (rowData) => {
    return (
      <div>
        <Form.Check
          type={"checkbox"}
          checked={selectedProducts.map((p) => p.id).includes(rowData.id)}
          onChange={() => {
            !selectedProducts.map((p) => p.id).includes(rowData.id)
              ? setSelectedProducts([...selectedProducts, rowData])
              : setSelectedProducts(
                  selectedProducts.filter((p) => p.id !== rowData.id)
                );
          }}
        />
      </div>
    );
  };
  const componentRef = useRef();

  let isFunctionRunning = false;

  const handlePay = async (rowData) => {
    if (isFunctionRunning) {
      return;
    }

    isFunctionRunning = true; // تعيين المتغير إلى true للإشارة إلى أن الدالة تعمل حاليًا

    const isOnline = navigator.onLine;

    if (!isOnline) {
      // رسالة عندما لا يكون هناك اتصال بالإنترنت
      Swal.fire({
        icon: "error",
        title: t("ship.no_internet"),
        text: t("orderDetails.alerts.internet.text"),
        confirmButtonText: t("orders.datatable_templating_demo.okay"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
      isFunctionRunning = false; // استعادة المتغير إلى false بمجرد انتهاء الدالة
      return;
    }

    if (
      account.subscription.tokens > 0 ||
      account.subscription.endDate.seconds > currentDate
    ) {
      setDoc(doc(db, "account", account.id), {
        ...account,
        subscription: !(account.subscription.endDate.seconds > currentDate)
          ? { ...account.subscription, tokens: account.subscription.tokens - 1 }
          : { ...account.subscription },
      }).then(
        updateDoc(doc(db, "orders", rowData?.id), {
          isValid: false,
        }).then(() => {
          isFunctionRunning = false; // استعادة المتغير إلى false بمجرد انتهاء الدالة
        })
      );
    } else {
      Swal.fire({
        icon: "error",
        title: t("ship.insufficient_balance"),
        text: t("ship.insufficient_balance_message"),
        confirmButtonText: t("ship.recharge_balance"),
        confirmButtonColor: "rgb(141, 93, 167)",
        showCancelButton: true,
        cancelButtonText: t("annule"),
        cancelButtonColor: "#e87778",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/plan";
        }
        isFunctionRunning = false; // استعادة المتغير إلى false بمجرد انتهاء الدالة
      });
    }
  };

  const notPaidTemplate = (rowData) => {
    const handleCopyPhone = async (phone, event) => {
      const showSuccessNotification = (targetElement) => {
        const rect = targetElement.getBoundingClientRect();

        const successMsg = document.createElement("div");
        successMsg.innerHTML = "✅ تم النسخ بنجاح!";
        successMsg.style.cssText = `
        position: fixed;
        top: ${rect.bottom + 10}px;
        left: ${rect.left + rect.width / 2}px;
        transform: translateX(-50%);
        background: linear-gradient(135deg, #4CAF50, #45a049);
        color: white;
        padding: 12px 20px;
        border-radius: 25px;
        font-size: 14px;
        font-weight: bold;
        z-index: 50;
        direction: rtl;
        font-family: Arial, sans-serif;
        box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
        border: 2px solid rgba(255, 255, 255, 0.3);
        animation: copySuccess 0.6s ease-out;
        white-space: nowrap;
      `;

        if (!document.getElementById("copy-success-animation")) {
          const style = document.createElement("style");
          style.id = "copy-success-animation";
          style.textContent = `
          @keyframes copySuccess {
            0% {
              opacity: 0;
              transform: translateX(-50%) translateY(-10px) scale(0.8);
            }
            50% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1.05);
            }
            100% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1);
            }
          }
          @keyframes copyFadeOut {
            0% {
              opacity: 1;
              transform: translateX(-50%) translateY(0) scale(1);
            }
            100% {
              opacity: 0;
              transform: translateX(-50%) translateY(-10px) scale(0.9);
            }
          }
        `;
          document.head.appendChild(style);
        }

        document.body.appendChild(successMsg);

        setTimeout(() => {
          successMsg.style.animation = "copyFadeOut 0.3s ease-in forwards";
          setTimeout(() => {
            if (document.body.contains(successMsg)) {
              document.body.removeChild(successMsg);
            }
          }, 300);
        }, 1700);
      };

      try {
        await navigator.clipboard.writeText(phone);
        showSuccessNotification(event.target);
      } catch (err) {
        console.error("Failed to copy: ", err);
        const textArea = document.createElement("textarea");
        textArea.value = phone;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        showSuccessNotification(event.target);
      }
    };

    return (
      <div>
        {rowData.isValid ? (
          <i className="fs-3" onClick={() => handlePay(rowData)}>
            <img src={"/lock.png"} className="mx-auto" />
          </i>
        ) : (
          <span
            style={{
              textDecoration: "none",
              color: "#007bff",
              cursor: "pointer",
            }}
            onClick={(e) => handleCopyPhone(rowData.phone, e)}
            title={t("ship.click_to_copy")} // Arabic tooltip: "Click to copy"
          >
            {rowData.phone}
          </span>
        )}
      </div>
    );
  };

  const imageBodyTemplate = (rowData) => {
    let productsToShow = [];
    const product = productdata.find(
      (product) => product.id === rowData.productId
    );
    if (rowData.products && rowData.products.length > 0) {
      productsToShow = rowData.products
        .slice(0, 2)
        .map((p) => productdata.find((product) => product.id === p.id));
    }

    return rowData?.products ? (
      <div
        onClick={() => navigateToOrder(rowData)}
        state={{
          from: { ...rowData },
          product: productdata.find(
            (product) => product.id === rowData.productId
          ),
          products: productsToShow,
        }}
      >
        <div
          className={`flex overflow-hidden ${
            isRTL === "ltr"
              ? "-space-x-2 flex-row-reverse"
              : "-space-x-2 -space-x-reverse"
          }`}
        >
          {rowData.products.slice(0, 2).map((product, index) => (
            <div className="relative">
              {rowData.stayOffer && (
                <img
                  src="/sale.png"
                  alt={t("ui.sale")}
                  className="absolute top-0"
                  style={{
                    right: window.innerWidth <= 768 ? "31px" : "37px",
                    zIndex: 50,
                    maxWidth: window.innerWidth <= 768 ? "18px" : "20px",
                  }}
                />
              )}
              <div key={index} className="relative">
                {/* عرض الأيقونة فقط إذا كانت rowData.stayOffer موجودة */}
                <img
                  src={product?.image || "/product-foorweb.png"}
                  height="75px"
                  alt={product?.name}
                  className={`rounded-lg overflow-hidden shadow-sm border-2 border-white w-14 h-14 bg-[#faf1ff] z-30 avatar${
                    index + 1
                  }`}
                  style={{
                    border: rowData?.stayOffer
                      ? "2px solid #e91b24"
                      : rowData?.isImaginary
                      ? "2px solid #ffb400"
                      : "2px solid white",
                  }}
                />
                {/* صورة المنتج مع الإطار الأحمر */}
              </div>
              {rowData.isImaginary && (
                <img
                  src="/euror.png"
                  alt="559384"
                  className="absolute bottom-0 l"
                  style={{
                    right: window.innerWidth <= 768 ? "27px" : "32px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
              {rowData.platform === "tiktok" && (
                <img
                  src="/foorchat.png" // حط لوجو تيك توك هنا
                  alt={t("navbar.try.tiktok")}
                  className="absolute top-0 right-0"
                  style={{
                    right: window.innerWidth <= 768 ? "27px" : "32px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
              {rowData.platform === "foorchat" && (
                <img
                  src="/foorchat.gif" // حط لوجو تيك توك هنا
                  alt="foorchat"
                  className="absolute top-0 right-0"
                  style={{
                    right: window.innerWidth <= 768 ? "27px" : "32px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
              {rowData.platform === "facebook" && (
                <img
                  src="/metaa.png" // حط لوجو ميتا/فيسبوك هنا
                  alt="Meta"
                  className="absolute top-0 left-0"
                  style={{
                    right: window.innerWidth <= 768 ? "27px" : "32px",
                    zIndex: 0,
                    maxWidth: window.innerWidth <= 768 ? "21px" : "22px",
                  }}
                />
              )}
            </div>
          ))}

          {rowData.products.length > 2 ? (
            <div className="relative">
              <div className="absolute top-0 left-0 text-white w-5 h-5 flex items-center justify-center rounded-full  bg-[#9b59bf] pt-1">
                {rowData.products.length > 2
                  ? `${rowData.products.length - 2}+`
                  : ""}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    ) : (
      <>
        {rowData.nameproduct ? (
          <Link
            to={`/orders/details`}
            state={{
              from: { ...rowData },
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={rowData.image ? rowData.image : "/product-foorweb.png"}
                  height="75px"
                  alt={rowData.nameproduct ? rowData.nameproduct : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        ) : (
          <Link
            to={`/orders/details`}
            state={{
              from: { ...rowData },
              product: productdata.filter(
                (product) => product.id === rowData.productId
              )[0],
              products: productdata,
            }}
          >
            <div className="flex -space-x-2 overflow-hidden">
              <div className="relative">
                <img
                  src={product ? product.image : "/product-foorweb.png"}
                  height="75px"
                  alt={product ? product.name : ""}
                  className="rounded-lg overflow-hidden shadow-sm border-2 border-white w-10 h-10 bg-[#faf1ff] avatar2"
                />
              </div>
            </div>
          </Link>
        )}
      </>
    );
  };

  const getUniqueDaysCount = (statusTimeline) => {
    if (!Array.isArray(statusTimeline)) return 0;

    const uniqueDates = new Set();

    statusTimeline.forEach((item) => {
      if (item.timestamp) {
        const timestamp = item.timestamp;
        const date = timestamp.seconds
          ? new Date(timestamp.seconds * 1000)
          : new Date(timestamp); // fallback

        const dayString = date.toISOString().split("T")[0]; // YYYY-MM-DD
        uniqueDates.add(dayString);
      }
    });

    return uniqueDates.size;
  };

  const checkAndUpdateStatusAtMidnight = async (order) => {
    const tentativesCount = getUniqueDaysCount(order.statusTimeline);
    if (tentativesCount >= 3) {
      const lastUpdate = order.lastStatusUpdate
        ? new Date(order.lastStatusUpdate.seconds * 1000)
        : null;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (!lastUpdate || lastUpdate < today) {
        await setDoc(doc(db, "orders", order.id), {
          ...order,
          status: 4, // Changé de deleveryStatus à status et de "6" à 4 (mرفوض)
          lastStatusUpdate: new Date(),
          statusTimeline: [
            ...(order.statusTimeline || []),
            {
              status: 4, // Changé de "6" à 4
              timestamp: new Date(),
              ownby: "Automatique",
            },
          ],
        });

        console.log(`Statut mis à jour pour la commande ${order.index}`);
      }
    }
  };

  const combinedTemplate = (rowData) => {
    const buttonImage =
      STATUS_CONFIG[rowData.status]?.image ||
      "https://cdn-icons-png.flaticon.com/512/10608/10608900.png";

    const allowedStatuses = getAllowedStatuses(rowData.status);
    if (allowedStatuses.length === 0) {
      return (
        <button className="flex items-center relative justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot mx-auto dark:bg-[#141414] dark:!text-gray-300 dark:!border-[#3c3a3d]">
          <img src={buttonImage} style={{ width: "20px" }} alt={t("ui.buttonIcon")} />
        </button>
      );
    }

    return (
      <Dropdown
        overlay={
          <Menu>
            {allowedStatuses.map((statusId, index) => (
              <div key={statusId}>
                {index > 0 && <hr className="m-0 p-0" />}
                <Menu.Item
                  key={statusId}
                  className={`ms-33 ss1 ${STATUS_CONFIG[statusId].icon} ${
                    rowData.status === statusId ? "selected" : ""
                  }`}
                  onClick={() => changeStatus(rowData, statusId)}
                >
                  <a className="s11">{STATUS_CONFIG[statusId].label}</a>
                </Menu.Item>
              </div>
            ))}
          </Menu>
        }
      >
        <div className="relative inline-block">
          <button className="flex items-center relative justify-center py-2.5 border rounded-lg hover:bg-gray-50 duration-150 active:bg-gray-100 bot mx-auto">
            <img
              src={buttonImage}
              style={{ width: "20px" }}
              alt={t("ui.buttonIcon")}
            />
          </button>
          {rowData.reminderCount > 0 && (
            <span className="absolute -top-2 -left-2 w-5 h-5 flex items-center justify-center text-xs font-bold text-white pt-1 bg-[#5a2b73]  rounded-full">
              {rowData.reminderCount}
            </span>
          )}
        </div>
      </Dropdown>
    );
  };

  return (
    <div className="datatable-templating-demo">
      <div className="bg-white dark:!bg-[#181919] rounded-t-xl p-4 border-y border-purple-100 dark:!border-[#3c3a3d]">
        <div className="flex flex-wrap items-center gap-3">
          {/* Selected Orders Label */}
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-700 ml-2 dark:text-gray-300">
              {t("orders.datatable_templating_demo.selected_orders")}:
            </span>
            <span className="bg-[#faf1ff] dark:bg-[#181919] text-[#9e68ba] px-2 py-0.5 rounded-md font-medium text-sm">
              {selectedProducts.length}
            </span>
          </div>

          {/* CSV Export Button */}
          <button
            disabled={selectedProducts.length < 1}
            className={`p-2 bg-white dark:!bg-[#141414] border ${
              selectedProducts.length < 1
                ? "border-gray-200 dark:!border-[#3c3a3d] opacity-50 cursor-not-allowed"
                : "border-purple-200 dark:!border-[#3c3a3d] hover:bg-purple-50"
            } rounded-lg transition-colors flex items-center gap-2`}
          >
            <CSVLink
              data={selectedProducts.map((p) => ({
                index: p.index,
                name: p.name,
                phone: p.isValid ? "***" : p.phone,
                state: p.state,
                commune: p.commune,
                address: p.address,
                product: p.nameproduct
                  ? p.nameproduct
                    ? p.nameproduct
                    : productdata.filter(
                        (product) => product.id === p.productId
                      )[0].name
                  : "منتج",
                options: p.options,
                qty: p.qty,
                deleveryPrice: p.deleveryPrice,
                total: p.total,
                sku: p.sku,
              }))}
              className={
                selectedProducts.length < 1 ? "pointer-events-none" : ""
              }
            >
              <div className="flex items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`${
                    selectedProducts.length < 1
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  }`}
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                <span
                  className={`${
                    selectedProducts.length < 1
                      ? "text-gray-400"
                      : "text-[#9e68ba]"
                  } text-sm font-medium`}
                >
                  {t("orders.datatable_templating_demo.export")}
                </span>
              </div>
            </CSVLink>
          </button>
          <iframe
            id="pdfPrinter"
            style={{ display: "none" }}
            title={t("ui.printPdf")}
          />

          {/* Order Status Dropdown */}
          <select
            disabled={selectedProducts.length < 1}
            className={`p-2 bg-white border dark:!bg-[#141414] ${
              selectedProducts.length < 1
                ? "border-gray-200 opacity-50 cursor-not-allowed dark:!border-[#3c3a3d] "
                : "border-purple-200 hover:bg-purple-50 dark:!border-[#3c3a3d] dark:text-gray-300"
            } rounded-lg text-sm ${
              selectedProducts.length < 1 ? "text-gray-400" : "text-gray-700 "
            } focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent`}
            required
            value={bluck}
            onChange={(e) => {
              setBluck(e.target.value);
            }}
          >
            <option value="">
              {t("orders.datatable_templating_demo.digital.statusSelect.label")}
            </option>
            <option value="0">
              {t(
                "orders.datatable_templating_demo.digital.statusSelect.options.0"
              )}
            </option>
            <option value="1">
              {t(
                "orders.datatable_templating_demo.digital.statusSelect.options.1"
              )}
            </option>
            <option value="2">
              {t(
                "orders.datatable_templating_demo.digital.statusSelect.options.2"
              )}
            </option>
            <option value="3">
              {t(
                "orders.datatable_templating_demo.digital.statusSelect.options.3"
              )}
            </option>
            <option value="7">
              {t(
                "orders.datatable_templating_demo.digital.statusSelect.options.7"
              )}
            </option>
            <option value="8">
              {t(
                "orders.datatable_templating_demo.digital.statusSelect.options.8"
              )}
            </option>
          </select>

          {/* Apply Button */}
          <button
            disabled={
              selectedProducts.length < 1 ||
              (bluck === "" && deleveryCompany === "")
            }
            onClick={groubeUpdates}
            className={`py-2 px-4 rounded-lg text-sm font-medium dark:!bg-[#141414] border dark:!border-[#3c3a3d] ${
              selectedProducts.length < 1 ||
              (bluck === "" && deleveryCompany === "")
                ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                : "bg-[#9b59bf] hover:bg-[#814a9f] dark:!text-[#9e68ba] text-white"
            } transition-colors`}
          >
            {t("orders.datatable_templating_demo.process_action")}
          </button>
        </div>
      </div>
      <div className="">
        <style>{darkModeStyles}</style>
        <DataTable
          value={
            !!filter
              ? orders.filter(
                  (order) =>
                    order.index
                      .toString()
                      .toLowerCase()
                      .includes(filter.toLowerCase()) ||
                    order.name.toLowerCase().includes(filter.toLowerCase()) ||
                    order.phone.toLowerCase().includes(filter.toLowerCase())
                )
              : _DATA.currentData()
          }
          responsiveLayout="scroll"
          rowExpansionTemplate={rowExpansionTemplate}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          emptyMessage={t("ship.no_results_found")}
          rowClassName={(rowData, rowIndex) =>
            rowIndex % 2 === 0 ? "p-row-odd" : "p-row-even"
          }
        >
          <Column
            className="text-end border-l dark:!border-[#3c3a3d]"
            header={
              <Form.Check
                type={"checkbox"}
                checked={selectedProducts.length === _DATA.currentData().length}
                onChange={() => {
                  selectedProducts.length === _DATA.currentData().length
                    ? setSelectedProducts([])
                    : setSelectedProducts([..._DATA.currentData()]);
                }}
              />
            }
            body={selectTemplate}
            style={{ width: "3rem" }}
          ></Column>
          <Column
            header={t("orders.datatable_templating_demo.product")}
            className="text-end"
            body={imageBodyTemplate}
          ></Column>
          {/*<Column body={orderNumber} field="index" className='text-end n-order' header="رقم الطلب" ></Column>*/}
          <Column
            body={customerName}
            field="name"
            className="text-end n-name"
            header={t("orders.datatable_templating_demo.customer")}
          ></Column>
          <Column
            field={notPaidTemplate}
            className="text-end n-phone"
            header={t("orders.datatable_templating_demo.phone_number")}
          ></Column>
          <Column
            body={dateBodyTemplate}
            className="text-end n-date"
            header={t("orders.datatable_templating_demo.order_date")}
          ></Column>

          <Column
            style={{ minWidth: "125px" }}
            header={t("orders.datatable_templating_demo.order_status")}
            className="text-end n-status1"
            body={combinedTemplate}
          ></Column>
          <Column
            style={{ color: "#6e4881" }}
            body={orderTotal}
            className="text-end n-total"
            header={t("orders.datatable_templating_demo.total")}
          ></Column>
          <Column
            header=""
            className="text-end n-delet"
            body={actionTemplate}
          ></Column>

          <Column expander style={{ width: "0em" }} />
        </DataTable>
      </div>

      <div className="d-flex justify-content-center py-3 dark:!bg-[#181919]">
        {
          <Stack spacing={2} dir="ltr">
            <Pagination
              count={count}
              size="large"
              page={page}
              variant="outlined"
              shape="rounded"
              onChange={handleChange}
              color="secondary"
              sx={{
                backgroundColor: isDark ? "#181919" : "#ffffff",
                borderRadius: 2,
                p: 2,
                "& .MuiPaginationItem-root": {
                  color: isDark ? "#e1cfff" : "#000000",
                  borderColor: isDark ? "#a065c0" : "#ccc",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: isDark ? "#9b59bf" : "#9b59bf",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: isDark ? "#7c3aad" : "#f0f0f0",
                },
              }}
            />
          </Stack>
        }
      </div>
      <div className="hidden">
        <ComponentToPrint
          ref={componentRef}
          data={selectedProducts}
          store={store}
          account={account}
          products={productdata}
        />
      </div>
    </div>
  );
};

export default DigitalProductsDataTable;
